import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form"]
  static classes = ["editing"]

  edit() {
    this.displayTargets.forEach(el => el.classList.add("hidden"))
    this.formTarget.classList.remove("hidden")
    this.element.classList.add(...this.editingClasses)
  }

  cancel() {
    this.displayTargets.forEach(el => el.classList.remove("hidden"))
    this.formTarget.classList.add("hidden")
    this.element.classList.remove(...this.editingClasses)
  }
}
